import { Button } from "components";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setIsDarkMode } from "store/globalSlice";
import { icons } from "utils/constants";
import { getDataFromLocalStorage, removeFromLocalStorage } from "utils/helpers";

const SubscriptionPaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  const payment_id = getDataFromLocalStorage("payment_id");

  const fetchPaymentDetails = async () => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  const redirectToHome = () => {
    navigate("/");
    removeFromLocalStorage("payment_id");
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      redirectToHome();
    }, 5000);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchPaymentDetails();
    if (localStorage.getItem("theme") === "dark") {
      dispatch(setIsDarkMode(true));
    } else {
      dispatch(setIsDarkMode(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isPartiallyPaid = window.location?.search?.split("=")?.pop()
    ? true
    : false;
  return (
    <div id="subscriptionpaymentsuccess-container">
      <div className={`${isDarkMode ? "bb-4d6c" : "bb-e3e3"} cpt-22 cpb-22`}>
        <div className="fb-center container">
          <div className="h-35">
            <img
              src={isDarkMode ? icons.logoDark : icons.logo}
              alt="logo"
              className="fit-image"
            />
          </div>
        </div>
      </div>
      <div className="body-block container mt-4">
        {loading ? (
          <div className="row f.center">
            <div className="col-md-12">
              <div
                className={`${
                  isDarkMode ? "skeleton-dark" : "skeleton"
                } h-200 br-10`}
              />
            </div>
          </div>
        ) : (
          <>
            <div className={`f-center br-12`}>
              <div
                className={`cp-20 b-dee3 br-12 ${
                  isDarkMode ? "bg-4d6c" : ""
                } w-450`}
              >
                <div className="f-center">
                  <img
                    src={icons.YesIcon}
                    alt="key"
                    className="fit-image w-70 h-70"
                  />
                </div>
                <div
                  className={`text-22-400 f-center cmt-20 ${
                    isDarkMode ? "color-ffff" : ""
                  }`}
                >
                  {isPartiallyPaid
                    ? "Your payment was partially paid!"
                    : "Your payment was successful!"}
                </div>
                <div
                  className={`flex-column text-16-400 ${
                    isDarkMode ? "color-c9c9" : "color-7e91"
                  } cmt-80 cmb-20 f-center`}
                >
                  {isPartiallyPaid ? (
                    <p>Please contact us for more details</p>
                  ) : (
                    <p>Payment Id: {payment_id ? payment_id : ""}</p>
                  )}
                  {/* <p>Invioce Id: 1111111</p> */}
                  <p className="w-300">
                    You will redirect to home page shortlty or click here to
                    return to home page
                  </p>
                </div>
                <div className="f-center">
                  <Button
                    btnStyle="PD"
                    btnText="Redirect To Home"
                    className="w-300"
                    onClick={() => {
                      navigate("/");
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SubscriptionPaymentSuccess;
